import apiCall from '@/utils/api-call'
import Urls from '@/router/urls'

export default {
  loadAgencies ({ commit, state }) {
    return apiCall.get(Urls.Agency())
      .then(res => {
        const agencies = res.data || []
        commit('SET_AGENCIES', agencies)

        if (state.selectedAgency) {
          // check if selected agency exists in the agency list from server
          const index = agencies.findIndex(a => a.id === state.selectedAgency.id)
          if (index === -1) {
            commit('SELECT_AGENCY', null)
            commit('SELECT_COMPANY', null)
            commit('SET_COMPANIES', [])
          }
        }

        // if user has only one agency assigned, select it
        if (agencies.length === 1) {
          commit('SELECT_AGENCY', agencies[0])
        }

        return true
      })
  },

  loadCompanies ({ commit, state }) {
    if (!state.selectedAgency) {
      commit('SELECT_COMPANY', null)
      commit('SET_COMPANIES', [])
      return
    }

    return apiCall.get(Urls.Company())
      .then(res => {
        const companies = res.data || []
        commit('SET_COMPANIES', companies)

        if (state.selectedCompany) {
          // check if selected agency exists in the agency list from server
          const index = companies.findIndex(c => c.id === state.selectedCompany.id)
          if (index === -1) {
            commit('SELECT_COMPANY', null)
          }
        }
      })
  },

  selectAgency ({ commit }, payload) {
    commit('SELECT_AGENCY', payload)
  },

  selectCompany ({ commit }, payload) {
    commit('SELECT_COMPANY', payload)
  },

  setDebugMode ({ commit }, payload) {
    commit('SET_DEBUG_MODE', payload)
  },

  setCurrentTab ({ commit }, payload) {
    commit('SET_CURRENT_TAB', payload)
  },

  setIsLoading ({ commit }, payload) {
    commit('SET_IS_LOADING', payload)
  },

  setOpenGroups ({ commit }, payload) {
    commit('SET_OPEN_GROUPS', payload)
  },

  setOpenSubSections ({ commit }, payload) {
    commit('SET_OPEN_SUB_SECTIONS', payload)
  },

  setSidebarVisible ({ commit }, payload) {
    commit('SET_SIDEBAR_VISIBLE', payload)
  },

  setShowEmptyNotice ({ commit }, payload) {
    commit('SET_SHOW_EMPTY_NOTICE', payload)
  },

  setShowCustomerPref ({ commit }, payload) {
    commit('SET_SHOW_CUSTOMER_PREF', payload)
  },

  setConceptEdit ({ commit }, payload) {
    commit('SET_CONCEPT_EDIT', payload)
  },

  setHasConcept ({ commit }, payload) {
    commit('SET_HAS_CONCEPT', payload)
  },

  setConsultationId ({ commit }, payload) {
    commit('SET_CONSULTATION_ID', payload)
  }
}
